module.exports = __webpack_public_path__ + "article-7051a3ee/uberzeugender-einleitungssatz-so-ge-471b754dfb49a3864adab5183fa4d3d8.jpeg";